import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useFileSources } from "@/composables/fileSources";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileSourceNameSpan',
    props: {
        uri: null,
        showFullUri: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { getFileSourceByUri } = useFileSources();
        const fileSource = computed(() => getFileSourceByUri(props.uri));
        const fileSourceName = computed(() => fileSource.value?.label ?? fileSource.value?.id);
        return { __sfc: true, props, getFileSourceByUri, fileSource, fileSourceName };
    }
});
